<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission != null">
      <div v-if="permission.read_perm == 1">
        <div style="width: 100%">
          <v-card elevation="0" class="px-3 py-2" style="width: 100%">
            <v-row>
              <v-col
                cols="12"
                class="d-flex"
                style="
                  position: relative;
                  padding: 0 20px;
                  text-align: center;
                  margin-top: 20px;
                "
              >
                <h6
                  class="indigo--text"
                  style="font-weight: bold; margin: auto"
                >
                  DASHBOARD AUDIT DSS
                </h6>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
// import axios from 'axios'
import buildType from '../../../services/buildType'
import { mapActions, mapGetters, mapMutations } from 'vuex'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'dssdashboard',
  data: () => ({
    dssApi: buildType.apiURL('dss'),
    config: require('../../../services/config.json')[env],
    screenWidth: 0,
    screenHeight: 0,
    isLoadingPage: true,
    permission: null,
    appLevel: null,
    userLevel: null,

    paramAPI: {
      // page: 1,
      // keyword: '',
      // offset: 0,
      // limit: 10,
      // sortBy: 'name',
      // sortType: 'asc',
      company_id: null
      // department_id: null,
      // level_id: null,
      // section_id: null,
      // itemsPerPage: 10
    }
  }),
  components: {},
  async mounted() {
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator

    this.screenWidth = screen.width
    this.screenHeight = screen.height

    // this.initChart()
    this.getDataMenu()
  },
  computed: {
    // ...mapGetters(['getUserProfile','getDssDasboardQuery'])
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setTabs']),

    async getDataMenu() {
      this.isLoadingPage = true
      await this.getMenuId({
        keyword: '',
        path: this.$route.path
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },

    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      if (this.userLevel.user_user_level.allowed_company !== null) {
        if (
          this.userLevel.user_user_level.allowed_company.find(
            ({ id }) => id == this.getUserProfile.employee.company.plant_id
          ) !== undefined
        ) {
          this.paramAPI.company_id = Number(
            this.getUserProfile.employee.company.plant_id
          )
        } else {
          this.paramAPI.company_id = Number(
            this.userLevel.user_user_level.allowed_company[0].id
          )
        }
      } else {
        this.paramAPI.company_id = Number(
          this.getUserProfile.employee.company.plant_id
        )
      }
      // if (this.getDssDasboardQuery != null) {
      //   this.paramAPI = this.getDssDasboardQuery
      // }
      setTimeout(async () => {
        // await this.getDataFromApi()
        this.setArrTabs()
      }, 200)
    },

    setArrTabs() {
      const tabsArr = [
        { tab_name: 'Dashboard', path: '/dss/audit/dashboard', isShown: false },
        {
          tab_name: 'Audit',
          path: '/dss/audit/list',
          isShown: false
        }
      ]
      if (
        this.getUserProfile.level.find(
          ({ id }) =>
            id == this.appLevel.administrator || id == this.appLevel.adminAudit
        ) !== undefined
      ) {
        tabsArr.push({
          tab_name: 'Master Data',
          path: '',
          sub_tabs: [
            {
              sub_title: 'Area',
              path: '/dss/audit/ms/area'
            },
            {
              sub_title: 'Kategori Klausul',
              path: '/dss/audit/ms/clausecategory'
            },
            {
              sub_title: 'Klausul',
              path: '/dss/audit/ms/clause'
            },
            {
              sub_title: 'Ruang Lingkup',
              path: '/dss/audit/ms/scope'
            },
            {
              sub_title: 'Scoring',
              path: '/dss/audit/ms/score'
            },
            {
              sub_title: 'Nilai',
              path: '/dss/audit/ms/grade'
            },
            {
              sub_title: 'Tipe Audit',
              path: '/dss/audit/ms/audittype'
            },
            {
              sub_title: 'Template Formulir',
              path: '/dss/audit/ms/formtemplate'
            }
          ],
          isShown: false
        })
      }
      this.setTabs(tabsArr)
    }
  }
}
</script>

<style lang="scss" src="">
#calendarView {
  position: relative;
  z-index: 2;
  //   display: flex;
  //   justify-content: center;
  //   flex-direction: column;
  //   align-items: center;
  min-height: 90vh;
  margin-bottom: 10px;
}
</style>
